(function ($, window, undefined) {
$(function onDomReady() {
  fixAmbassadorRedirect();
  yourConsultantWidget();
  // ensureRepUtmParams();
  trackRep();
});

function fixAmbassadorRedirect() {
  //if ( ! document.cookie || ( document.cookie.indexOf( 'pr_debug=1' ) === -1 ) ) return;
  if ( ! window.location || ! location.search || ( location.search.indexOf( 'utm_source=ambassador' ) === -1 ) ) return;

  var adjustedSearch = decodeURIComponent( location.search );
  adjustedSearch = adjustedSearch.replace( /&amp;/gi, '&' );
  if ( location.search === adjustedSearch ) return;

  if ( window.history && window.history.replaceState ) {
    history.replaceState( null, '', adjustedSearch );
  }
  else {
    location.search = adjustedSearch;
  }
}

function trackRep() {
  if ( ! window.icRep ) return;

  var repName = IC_Cookie.get( 'ic_rep_name' );
  if ( ! repName ) return;

  var attributes = icRep.attributes ? icRep.attributes : [];
  var trackedConsultant = false;
  $.each( attributes, function( index, item ) {
    if ( item.key === 'Consultant' ) {
      trackedConsultant = item.value;
    }
  } );

  if ( ! trackedConsultant ) {
    $.post('/cart/update.js', {attributes: {
      'Consultant': repName
    } });
  }
}

/*
function ensureRepUtmParams() {

  var pathname = window && window.location && window.location.pathname ? window.location.pathname : '';
  if ( pathname.search('/cart') === -1 ) return;

  var repName = IC_Cookie.get( 'ic_rep_name' );
  if ( ! repName ) return;

  var queryParams = new URLSearchParams(window.location.search);
  var hasUtmSource = queryParams.get( 'utm_source' ) === 'ambassador';
  var hasRepName = queryParams.get( 'utm_campaign' ) === repName;

  if ( ! hasUtmSource || ! hasRepName ) {
    window.location.search = '?utm_source=ambassador&utm_campaign=' + repName;
  } 
}
*/

function yourConsultantWidget() {
  maybeChangeRep();
  var repName = IC_Cookie.get( 'ic_rep_name' );
  if ( ! repName ) return;

  getYourConsultantWidget( repName, function( widgetHtml ) {
    $('.widgetarea-head').append( widgetHtml );
  } );
}

function getYourConsultantWidget( repName, callback ) {

  // See if we have it cached
  if ( isLocalStorageSupported() ) {
    var widget;
    try {
      widget = JSON.parse( localStorage.getItem( 'ic_rep_widget' ) );
    }
    catch(err) {
      widget = {};
    }

    if ( widget && widget.name && ( widget.name == repName ) ) {
      if ( widget.timestamp && ( widget.timestamp > Date.now() - 3600000 ) ) {
        if ( widget.html ) return callback( widget.html );
      }
      else {
        localStorage.removeItem( 'ic_rep_widget' );
      }
    }

  }

  $.get({
      url: 'https://backoffice.imperialcandles.co.uk/?get_shopify_rep_widget=' + repName,
      crossDomain: true,
      xhrFields: {
        withCredentials: true
      }
    }, function( widgetHtml, status, xhr ) {
      widgetHtml = $.trim( widgetHtml );
      if ( widgetHtml ) {
        localStorage.setItem( 'ic_rep_widget', JSON.stringify( {
          html: widgetHtml,
          timestamp: Date.now(),
          name: repName
        } ) );
        return callback( widgetHtml );
      }
    }
  );
}

function maybeChangeRep() {
  // https://dragonsden.imperialcandles.co.uk/?utm_source=ambassador&utm_campaign=kira
  var queryParams = new URLSearchParams(window.location.search);
  if ( queryParams.get( 'utm_source' ) !== 'ambassador' ) return;
  var repName = queryParams.get( 'utm_campaign' );
  repName = $.trim( repName );
  if ( ! repName ) return;

  IC_Cookie.set( 'ic_rep_name', repName, { expires: 365 } );
}


function isLocalStorageSupported() {
  try {
    var key = "_ic_ls_test_";
    localStorage.setItem( key, key );
    localStorage.removeItem( key );
    return true;
  } catch (e) {
    return false;
  }
};


/*! (c) Andrea Giammarchi - ISC => https://github.com/ungap/url-search-params */
if ( ! window.URLSearchParams ) {
  var self=this||{};try{!function(t,e){if(new t("q=%2B").get("q")!==e||new t({q:e}).get("q")!==e||new t([["q",e]]).get("q")!==e||"q=%0A"!==new t("q=\n").toString()||"q=+%26"!==new t({q:" &"}).toString()||"q=%25zx"!==new t({q:"%zx"}).toString())throw t;self.URLSearchParams=t}(URLSearchParams,"+")}catch(t){!function(t,a,o){"use strict";var u=t.create,h=t.defineProperty,e=/[!'\(\)~]|%20|%00/g,n=/%(?![0-9a-fA-F]{2})/g,r=/\+/g,i={"!":"%21","'":"%27","(":"%28",")":"%29","~":"%7E","%20":"+","%00":"\0"},s={append:function(t,e){p(this._ungap,t,e)},delete:function(t){delete this._ungap[t]},get:function(t){return this.has(t)?this._ungap[t][0]:null},getAll:function(t){return this.has(t)?this._ungap[t].slice(0):[]},has:function(t){return t in this._ungap},set:function(t,e){this._ungap[t]=[a(e)]},forEach:function(e,n){var r=this;for(var i in r._ungap)r._ungap[i].forEach(t,i);function t(t){e.call(n,t,a(i),r)}},toJSON:function(){return{}},toString:function(){var t=[];for(var e in this._ungap)for(var n=v(e),r=0,i=this._ungap[e];r<i.length;r++)t.push(n+"="+v(i[r]));return t.join("&")}};for(var c in s)h(f.prototype,c,{configurable:!0,writable:!0,value:s[c]});function f(t){var e=u(null);switch(h(this,"_ungap",{value:e}),!0){case!t:break;case"string"==typeof t:"?"===t.charAt(0)&&(t=t.slice(1));for(var n=t.split("&"),r=0,i=n.length;r<i;r++){var a=(s=n[r]).indexOf("=");-1<a?p(e,g(s.slice(0,a)),g(s.slice(a+1))):s.length&&p(e,g(s),"")}break;case o(t):for(r=0,i=t.length;r<i;r++){var s;p(e,(s=t[r])[0],s[1])}break;case"forEach"in t:t.forEach(l,e);break;default:for(var c in t)p(e,c,t[c])}}function l(t,e){p(this,e,t)}function p(t,e,n){var r=o(n)?n.join(","):n;e in t?t[e].push(r):t[e]=[r]}function g(t){return decodeURIComponent(t.replace(n,"%25").replace(r," "))}function v(t){return encodeURIComponent(t).replace(e,d)}function d(t){return i[t]}self.URLSearchParams=f}(Object,String,Array.isArray)}!function(d){var r=!1;try{r=!!Symbol.iterator}catch(t){}function t(t,e){var n=[];return t.forEach(e,n),r?n[Symbol.iterator]():{next:function(){var t=n.shift();return{done:void 0===t,value:t}}}}"forEach"in d||(d.forEach=function(n,r){var i=this,t=Object.create(null);this.toString().replace(/=[\s\S]*?(?:&|$)/g,"=").split("=").forEach(function(e){!e.length||e in t||(t[e]=i.getAll(e)).forEach(function(t){n.call(r,t,e,i)})})}),"keys"in d||(d.keys=function(){return t(this,function(t,e){this.push(e)})}),"values"in d||(d.values=function(){return t(this,function(t,e){this.push(t)})}),"entries"in d||(d.entries=function(){return t(this,function(t,e){this.push([e,t])})}),!r||Symbol.iterator in d||(d[Symbol.iterator]=d.entries),"sort"in d||(d.sort=function(){for(var t,e,n,r=this.entries(),i=r.next(),a=i.done,s=[],c=Object.create(null);!a;)e=(n=i.value)[0],s.push(e),e in c||(c[e]=[]),c[e].push(n[1]),a=(i=r.next()).done;for(s.sort(),t=0;t<s.length;t++)this.delete(s[t]);for(t=0;t<s.length;t++)e=s[t],this.append(e,c[e].shift())}),function(f){function l(t){var e=t.append;t.append=d.append,URLSearchParams.call(t,t._usp.search.slice(1)),t.append=e}function p(t,e){if(!(t instanceof e))throw new TypeError("'searchParams' accessed on an object that does not implement interface "+e.name)}function t(e){var n,r,i,t=e.prototype,a=v(t,"searchParams"),s=v(t,"href"),c=v(t,"search");function o(t,e){d.append.call(this,t,e),t=this.toString(),i.set.call(this._usp,t?"?"+t:"")}function u(t){d.delete.call(this,t),t=this.toString(),i.set.call(this._usp,t?"?"+t:"")}function h(t,e){d.set.call(this,t,e),t=this.toString(),i.set.call(this._usp,t?"?"+t:"")}!a&&c&&c.set&&(i=c,r=function(t,e){return t.append=o,t.delete=u,t.set=h,g(t,"_usp",{configurable:!0,writable:!0,value:e})},n=function(t,e){return g(t,"_searchParams",{configurable:!0,writable:!0,value:r(e,t)}),e},f.defineProperties(t,{href:{get:function(){return s.get.call(this)},set:function(t){var e=this._searchParams;s.set.call(this,t),e&&l(e)}},search:{get:function(){return c.get.call(this)},set:function(t){var e=this._searchParams;c.set.call(this,t),e&&l(e)}},searchParams:{get:function(){return p(this,e),this._searchParams||n(this,new URLSearchParams(this.search.slice(1)))},set:function(t){p(this,e),n(this,t)}}}))}var g=f.defineProperty,v=f.getOwnPropertyDescriptor;try{t(HTMLAnchorElement),/^function|object$/.test(typeof URL)&&URL.prototype&&t(URL)}catch(t){}}(Object)}(self.URLSearchParams.prototype,Object);
}


/**
 * Minified by jsDelivr using Terser v3.14.1.
 * Original file: /npm/js-cookie@2.2.1/src/js.cookie.js
 * 
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 * https://github.com/js-cookie/js-cookie
 */
!function(e){var n;if("function"==typeof define&&define.amd&&(define(e),n=!0),"object"==typeof exports&&(module.exports=e(),n=!0),!n){var t=window.Cookies,o=window.Cookies=e();o.noConflict=function(){return window.Cookies=t,o}}}(function(){function e(){for(var e=0,n={};e<arguments.length;e++){var t=arguments[e];for(var o in t)n[o]=t[o]}return n}function n(e){return e.replace(/(%[0-9A-Z]{2})+/g,decodeURIComponent)}return function t(o){function r(){}function i(n,t,i){if("undefined"!=typeof document){"number"==typeof(i=e({path:"/"},r.defaults,i)).expires&&(i.expires=new Date(1*new Date+864e5*i.expires)),i.expires=i.expires?i.expires.toUTCString():"";try{var c=JSON.stringify(t);/^[\{\[]/.test(c)&&(t=c)}catch(e){}t=o.write?o.write(t,n):encodeURIComponent(String(t)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),n=encodeURIComponent(String(n)).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent).replace(/[\(\)]/g,escape);var f="";for(var u in i)i[u]&&(f+="; "+u,!0!==i[u]&&(f+="="+i[u].split(";")[0]));return document.cookie=n+"="+t+f}}function c(e,t){if("undefined"!=typeof document){for(var r={},i=document.cookie?document.cookie.split("; "):[],c=0;c<i.length;c++){var f=i[c].split("="),u=f.slice(1).join("=");t||'"'!==u.charAt(0)||(u=u.slice(1,-1));try{var a=n(f[0]);if(u=(o.read||o)(u,a)||n(u),t)try{u=JSON.parse(u)}catch(e){}if(r[a]=u,e===a)break}catch(e){}}return e?r[e]:r}}return r.set=i,r.get=function(e){return c(e,!1)},r.getJSON=function(e){return c(e,!0)},r.remove=function(n,t){i(n,"",e(t,{expires:-1}))},r.defaults={},r.withConverter=t,r}(function(){})});
//# sourceMappingURL=/sm/b0ce608ffc029736e9ac80a8dd6a7db2da8e1d45d2dcfc92043deb2214aa30d8.map
var IC_Cookie = Cookies.noConflict();

})(window.Checkout && Checkout.$ ? Checkout.$ : jQuery, window);
